<template>
	<div class="img-wrap text-center" :class="{'has-more': mediaMore}">
		<!-- <iframe :src="`https://www.youtube.com/embed/${idVideoYoutube(pathView)}`" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen autoplay></iframe> -->
		<!-- <iframe :src="`https://www.youtube.com/embed/${idVideoYoutube(pathView)}?autoplay=1&rel=0&loop=1`" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen autoplay></iframe> -->
		<iframe :src="`https://www.youtube.com/embed/${idVideoYoutube(pathView)}?autoplay=${autoplay ? 1 : 0}&rel=0`" frameborder="0" :allow="`${autoplay ? 'autoplay; encrypted-media;' : 'encrypted-media;'}`"></iframe>
	</div>
</template>

<script>
	// import { APP_CONFIG } from '@/utils/constants'

	export default {
		name: 'PreviewYoutube',
		props: {
            pathView: String,
            mediaMore: Boolean,
            autoplay: Boolean
        },
		data() {
			return {
				// appUrl: APP_CONFIG.appUrl,
				// urlCmsImg: APP_CONFIG.urlCmsImg
			}
		},
		methods: {
			idVideoYoutube(link) {
				return link.split('?v=')[1];
			}
		}
	}
</script>

<style lang="scss" scoped>
	iframe {
		width: 83.5vw;
		height: 75vh;

		@media screen and ( min-width: 1200px ) and ( max-width: 1799px ) {
			height: 70vh;
		}

		@media screen and ( min-width: 768px ) and ( max-width: 1199px ) {
			height: 39vh;
		}
		@media screen and ( min-width: 576px ) and ( max-width: 767px ) {
			height: 30vh;
		}
		@media screen and ( max-width: 575px ) {
			height: 27vh;
		}
	}

	.has-more {
		iframe {
			height: 65vh;

			@media screen and ( min-width: 1200px ) and ( max-width: 1799px ) {
				height: 54vh;
			}
		}
	}
</style>